import { get, post, put } from "./api_helper"

export const getProductCategoryAPI = params =>
  get("admin/master/product-category/page", params)

export const getProductCategoryListAPI = params =>
  get("admin/master/product-category/list", params)

export const getProductCategoryByIdAPI = id =>
  get(`admin/master/product-category/${id}`)

export const postProductCategoryAPI = data =>
  post("admin/master/product-category", data)

export const putProductCategoryAPI = (data, id) =>
  put(`admin/master/product-category/${id}`, data)
